var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-textarea',{attrs:{"label":"Email from contact form"},model:{value:(_vm.emailContents),callback:function ($$v) {_vm.emailContents=$$v},expression:"emailContents"}}),_c('v-btn',{on:{"click":_vm.processEmail}},[_vm._v("Import")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }